import React, { useEffect } from 'react';
import { setPartnerCookie } from '../utils/cookie';
import Newsletter from './Common/Newsletter';
import Footer from './Footer';

const Layout = ({ children }) => {
  useEffect(() => {
    setPartnerCookie();
  }, []);

  return (
    <div className="font-sans antialiased leading-tight text-gray-700 bg-gray-50 print:bg-white">
      {children}
      <div className="print:hidden">
        <Newsletter />
        {/* <Trusted /> */}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
